<template>
    <div class="login-content">
        <div class="login-content-title">邮箱登录</div>
        <el-form :model="login" :rules="loginRules" ref="loginForm" name="login" key="login">
            <el-form-item prop="email" class="login-form__item">
                <el-input
                    type="text"
                    name="email"
                    key="login-email-input"
                    placeholder="邮箱账号"
                    v-model="login.email"
                />
            </el-form-item>
            <el-form-item prop="password" class="login-form__item">
                <el-input
                    type="password"
                    name="password"
                    key="login-password-input"
                    placeholder="密码"
                    show-password
                    v-model="login.password"
                />
            </el-form-item>
            <el-button
                type="primary"
                style="width: 100%"
                :loading="loginBtnLoading"
                @click="handleLogin"
            >登录</el-button>
        </el-form>
        <div class="forget-password__button">
            <span @click="changePage(1)">注册邮箱</span>
            <span @click="changePage(3)">忘记密码</span>
        </div>
        <div class="login-type__icon" @click="wxLogin">
            <div class="login-icon">
                <svg-icon class="login-wechat" iconClass="wechat"/>
            </div>
            <div class="login-name">微信登录或注册</div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'DialogLogin',
        inject: ['reload'],
        data() {
            return {
                login: {
                    email: '',
                    password: ''
                },
                loginRules: {
                    email: [
                        { required: true, message: '请输入国内邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的国内邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                },
                loginBtnLoading: false
            };
        },
        methods: {
            ...mapActions('user', ['Login']),
            changePage(type) {
                this.$emit('changePage', type);
            },
            closeDialog() {
                this.$emit('closeDialog');
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        const params = {
                            ...this.login
                        };
                        this.loginBtnLoading = true;
                        this.Login(params).then(res => {
                            if (res.code === 0) {
                                this.$message.success({
                                    message: '登录成功',
                                    duration: 1000
                                });
                                this.$store.dispatch('user/getUserInfo');
                                this.closeDialog();
                                this.reload();
                            }
                        }).finally(() => {
                            this.loginBtnLoading = false;
                        });
                    }
                });
            },
            wxLogin() {
                localStorage.setItem('path', this.$route.path);
                var url = window.location.protocol+"//"+window.location.host;
                window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxc78ed9988e859851&redirect_uri=${url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
            }
        }
    };
</script>

<style lang="scss" scoped>
.login-content {
    &-title {
        margin-bottom: 40px;
        @include font(rgba(29, 35, 39, 1), 20px, 600);
    }
    &-title--warning {
        margin-bottom: 40px;
        @include font(rgba(247, 101, 84, 1), 20px, 600);
    }
    .login-form__item {
        margin-bottom: 32px;
    }

    .forget-password__button {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        @include font(rgba(145, 145, 145, 1), 16px, 400);
        span {
            &:hover {
                color: #A8ADC1;
            }
            cursor: pointer;
            &:first-child{
                @include font(rgba(47, 84, 235, 1), 16px, 400);
                &:hover {
                    color:#597EF7
                }
            }
        }
    }

    .login-type {
        width: 70%;
        margin: 51px auto 0;
        text-align: center;
        border-top: 1px solid #eee;
        span {
            display: block;
            width: 45%;
            margin: -9px auto 0;
            background: #fff;
            @include font(#999999, 14px, 400); 
        }
    }
    .login-type__icon{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 30px;
        padding: 0 20px;
        font-weight: 350;
        font-size: 12px;
        color: #606266;
        .login-wechat {
            color: #FFFFFF;
            font-size: 20px;
        }
        .login-name {
            cursor: pointer;
        }
        .login-icon {
            width: 37px;
            height: 37px;
            margin-bottom: 5px;
            border-radius: 100%;
            background-color:#3BC23B ;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover {
                background-color: #87E287;
            }
        }
    }
}
</style>
